import { PropsWithChildren } from "react";
import { Spinner } from "./Spinner";

export interface SpinnerProps extends PropsWithChildren {
    show: boolean;
    fullWidth?: boolean;
}

export const SpinnerContainer: React.FC<SpinnerProps> = (props) => {
    return (
        <div className={`${props.fullWidth ? "w-full h-full" : "w-fit"} relative h-fit`}>
            {props.children}
            <>
            {props.show &&
            <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-white/60 z-10"><div><Spinner/></div></div>
            }
            </>
        </div>
    )   
}